import styled from 'styled-components';

// A simple skeleton ui for text which is currently loading; shows a gray bar.
// It's approximately the height of average text in the current font size (0.8em),
// so it looks sort of like text when you squint.
//
//   <SkeletonText />
//   <SkeletonText width={80} />
//
// See https://git.hubteam.com/HubSpot/conversations-skeleton-state

const getSize = value => typeof value === 'number' ? `${value}px` : value;
const SkeletonText = styled.span.withConfig({
  displayName: "SkeletonText",
  componentId: "sc-17fk2bz-0"
})(({
  theme,
  backgroundColor,
  width,
  height,
  rounded
}) => `
  background-color: ${backgroundColor || theme.color['fill-tertiary-default']};
  border-radius: ${rounded ? '999px' : '5px'};
  display: inline-block;
  height: ${getSize(height || '0.8em')};
  width: ${getSize(width || '6em')};
`);
export default SkeletonText;